/**
 * @generated SignedSource<<38e72a086943da50b454d40952b97bdc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type BudgetDeleteInputObject = {
  id: string;
};
export type useBudgetEditor_DeleteMutation$variables = {
  input: BudgetDeleteInputObject;
};
export type useBudgetEditor_DeleteMutation$data = {
  readonly budgetDelete: {
    readonly budget: {
      readonly id: string;
    } | null | undefined;
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
  } | null | undefined;
};
export type useBudgetEditor_DeleteMutation = {
  response: useBudgetEditor_DeleteMutation$data;
  variables: useBudgetEditor_DeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Budget",
  "kind": "LinkedField",
  "name": "budget",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useBudgetEditor_DeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BudgetDeleteMutationPayload",
        "kind": "LinkedField",
        "name": "budgetDelete",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useBudgetEditor_DeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BudgetDeleteMutationPayload",
        "kind": "LinkedField",
        "name": "budgetDelete",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "25407994b6d9154cfccd5dabd5520cf3",
    "id": null,
    "metadata": {},
    "name": "useBudgetEditor_DeleteMutation",
    "operationKind": "mutation",
    "text": "mutation useBudgetEditor_DeleteMutation(\n  $input: BudgetDeleteInputObject!\n) {\n  budgetDelete(input: $input) {\n    budget {\n      id\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0e44354f29e4aeff652ab77c87afba9c";

export default node;
